<script lang="ts">
import { defineComponent, PropType, toRef } from 'vue'
import InputLeadFormWrapper from '@/components/lead/InputLeadFormWrapper.vue'
import InputKanji from '@/components/lead/InputKanji.vue'
import { formDefaultProps, formPartial } from '@/models/formPartial'

export default defineComponent({
  name: 'InputFormKanji',

  components: {
    InputLeadFormWrapper,
    InputKanji,
  },

  props: {
    modelValue: {
      type: String,
      default: '',
    },

    modelValueKana: {
      type: String,
      default: '',
    },

    /**
     * 入力フィールド（input 要素）に付与する ID 属性値
     * @description 未指定の場合、InputKnaji コンポーネントが自動で算出する id が付与される
     */
    fieldId: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    /**
     * autocomplete 属性に渡す値
     * @see https://developer.mozilla.org/ja/docs/Web/HTML/Attributes/autocomplete
     */
    autocomplete: {
      type: String as PropType<AutocompleteAttr>,
      default: 'off',
    },

    maxlength: {
      type: Number,
      default: undefined,
    },

    ...formDefaultProps,
  },

  emits: ['update:modelValue', 'update:modelValueKana'],

  setup(props) {
    const { hasError } = formPartial(props.name, toRef(props, 'validationScheme'))

    return {
      // computed
      hasError,
    }
  }
})
</script>

<template>
  <InputLeadFormWrapper
    :model-value="modelValue"
    :header="header"
    :namespace="namespace"
    :name="name"
    :is-disabled="isDisabled"
    :validation-scheme="validationScheme">
    <InputKanji
      :field-id="fieldId"
      :model-value="modelValue"
      :model-value-kana="modelValueKana"
      :name="name"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :maxlength="maxlength"
      :is-disabled="isDisabled"
      :readonly="readonly"
      :is-error="hasError"
      @update:model-value="$emit('update:modelValue', $event)"
      @update:model-value-kana="$emit('update:modelValueKana', $event)" />
  </InputLeadFormWrapper>
</template>
